<template>
  <b-card class="errorpage-card">
    <section>
      <header class="text-align-center">
        <img class="brand" src="@/assets/logo.png" />
      </header>
      <div class="body">
        <h1 class="display-3 mr-4">500</h1>
        <p class="text-muted auth-message">Well, @#$%. Something went really wrong. This will show up in our logs,
          but it would be really cool of you if you reported it to us also.</p>
        <br/>
        <b-link :to="{name: 'Dashboard'}">
          <b-button variant="success">Return to Dashboard</b-button>
        </b-link>
      </div>
    </section>
  </b-card>
</template>

<script>
export default {
  name: 'Page500',
  beforeCreate () {
    document.body.classList.add('error-page')
  },
  beforeDestroy () {
    document.body.classList.remove('error-page')
  }
}
</script>
